// extracted by extract-css-chunks-webpack-plugin
module.exports = {"blog__wrapper":"blog__wrapper","blog__title":"blog__title","blog__date":"blog__date","blog__entry":"blog__entry"};